import React, { ReactNode } from 'react';
import Form from 'react-bootstrap/Form';
import classes from './InlineFieldRow.module.scss';

interface InlineFieldRowProps {
  label: ReactNode
  children: ReactNode
  // Associates the label with a caller-rendered control (e.g. a <select>), like Form.Label's own htmlFor.
  htmlFor?: string
}

// A field's label beside its control on one line, at a fixed width shared by every consumer so
// labels line up across sections. Too little room wraps the label above instead of clipping it.
export function InlineFieldRow(props: InlineFieldRowProps) {
  const { label, children, htmlFor } = props;
  return (
    <Form.Group className={classes.row}>
      <Form.Label className={classes.label} htmlFor={htmlFor}>{label}</Form.Label>
      <div className={classes.control}>{children}</div>
    </Form.Group>
  );
}
